import { render, staticRenderFns } from "./TaskletPlaceholderComponent.vue?vue&type=template&id=168aec38&scoped=true&"
import script from "./TaskletPlaceholderComponent.vue?vue&type=script&lang=js&"
export * from "./TaskletPlaceholderComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskletPlaceholderComponent.vue?vue&type=style&index=0&id=168aec38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168aec38",
  null
  
)

export default component.exports